import { AnyAction } from "redux";
import { actionCreator } from "@ps/utils";
import ActionTypes from "./actionTypes";
import { IAction } from "../types";

export const setPermissions = (payload: IAction<string>): AnyAction =>
  actionCreator(ActionTypes.SET_PERMISSIONS, payload);
export const clearPermissions = (): AnyAction =>
  actionCreator(ActionTypes.CLEAR_PERMISSIONS, []);
